import React, { PropsWithChildren } from 'react';

import { withEventScope } from '@repo/event-processor';

import { bannerStoreSelector, useBannerStore } from 'stores/bannerStore';

import { PopoverBackground, PopoverContentWrapper } from './styles';

interface HeaderPopoverProps {
  visible: boolean;
}

const HeaderPopover: React.FC<PropsWithChildren<HeaderPopoverProps>> = ({
  visible,
  children,
}) => {
  const isBannerVisible = useBannerStore(bannerStoreSelector.isVisible);
  return (
    <PopoverBackground>
      <PopoverContentWrapper
        additionalPadding={isBannerVisible ? '20px' : undefined}
        visible={visible}
      >
        {children}
      </PopoverContentWrapper>
    </PopoverBackground>
  );
};

export default withEventScope(HeaderPopover, { module: 'headerPopover' });
